import GraphQLClientService from '../../services/GraphQLClientService';
import { FlurstuckEntity } from "../../ResponseObjects/Schemas/FlurstuckEntity";
import { RiskAreaEntity } from '../../ResponseObjects/Schemas/RiskAreaEntity';
import { Stage, GeometryType } from '../../constants/progress';
import { useProgressStore } from '../../store/progressStore';

export default async function fetchRiskAreaData(minX, minY, maxX, maxY) {
  const updateProgress = useProgressStore.getState().updateProgress;
  const geometryType = GeometryType.RISKAREA;
  if (minX === undefined || minY === undefined || maxX === undefined || maxY === undefined) {
    updateProgress(geometryType,{
      stage: Stage.ERROR,
      message: "Missing bounding box",
      error: "All boundary parameters (minX, minY, maxX, maxY) are required"
    });
    throw new Error('All boundary parameters (minX, minY, maxX, maxY) are required');
  }
  updateProgress(geometryType,
    {
      stage: Stage.QUERY,
      message:'Fetching data from server',
      progress: 25,
      error: null
    }
  )

  const query = `query RiskAreaByBounds 
  {
    riskAreaByBounds(
      minLat: ${maxY}
      minLon:${maxX}
      maxLat: ${minY}
      maxLon: ${minX}
      outputCRS: EPSG25832
      revitProtocol: true
      
    ) {
        riskAreas {
            exteriorRing {
                coordinates {
                    x
                    y
                    z
                }
            }
            interiorRings {
                coordinates {
                    x
                    y
                    z
                }
            }
            waterType
            objectId
            waterName
            isClipped
            id
            waterIdentifier
        }
      }
  }`;

 

  const client = new GraphQLClientService();

  try {
    const response = await client.executeQueryAsync(query);
    if(response == "TimedOUT")
    {
       updateProgress(geometryType,{
          stage: Stage.TIMEDOUT,
          message:"Timed out",
          progress:0,// need to change the progress
          
        })
        return null;

    }
    else
    {
      if (response.data.riskAreaByBounds.riskAreas.length>0) {
        updateProgress(geometryType,{
          stage: Stage.QUERYSTAGE,
          message:"Fetched data from the server",
          progress:50,// need to change the progress
          fetched: response.data.riskAreaByBounds.length
        })
        const riskAreaEntities = RiskAreaEntity.fromResponse(response);
        console.log("Rist entities: ", riskAreaEntities)
          updateProgress(geometryType,{
            stage: Stage.PROCESSINGSTAGE,
            message:"Processed fetched data from the server",
            progress:50,// need to change the progress
            processed: riskAreaEntities.length
          })
        return riskAreaEntities;
      } else {
          updateProgress(geometryType,{
            stage: Stage.NULL,
            message:"No data returned or an error occurred.",
            progress:50,// need to change the progress
            
          })
        console.log('No data returned or an error occurred.');
        return null;
      } 
    }
    

  } catch (error) {
     updateProgress(geometryType,{
        stage: Stage.ERROR,
        message:"Error during GraphQL request",
        progress:50,// need to change the progress
        
      })
    console.error('Error during GraphQL request:', error);
    throw error; 
  }
}